export const NDC_REG_EXP = /^(?<labelerCode>[0-9]{4,5})-(?<productCode>[0-9]{3,4})-(?<packageSize>[0-9]{1,2})$/;
export const NDC_11_DIGIT_BILLING = /^(?<labelerCode>[0-9]{5})(?<productCode>[0-9]{4})(?<packageSize>[0-9]{2})$/;
